export enum Route {
    MailLogItems = "/mail-log-items",
    MailLogItemsUser = "/mail-log-items/user",
    MailLogItemsUserStatistics = "/mail-log-items/user/statistics",
    MailLogItemsRegenerateQualityStatementPrefill = "/mail-log-items/resend-prefill"
}